import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { sentry } from '@services/Sentry';
import {
    defaultCaseStatuses,
    defaultCountries,
    defaultTranslations,
    defaultUserRelationship,
} from '@services/TranslationsService/defaultTranslations';

const missingKeys: string[] = [];

const resources = {
    EN: {
        caseStatus: defaultCaseStatuses,
        countries: defaultCountries,
        translations: defaultTranslations,
        userRelationship: defaultUserRelationship,
    },
};

void i18n.use(initReactI18next).init({
    defaultNS: 'translations',
    fallbackLng: 'EN',
    interpolation: {
        escapeValue: false,
    },
    keySeparator: false,
    lng: 'EN',
    missingKeyHandler: (_lngs, _ns, key) => {
        if (key && !missingKeys.includes(key)) {
            sentry.captureLackOfTranslation(key);
            missingKeys.push(key);
        }
    },
    resources,
    saveMissing: true,
});

export default i18n;
